import { falAngleDown } from 'shared/@generated/icons/falAngleDown';
import { Platform, TouchableOpacity, View } from 'react-native';
import { Text } from 'shared/components/text';
import { Icon } from 'shared/components/icon';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Props } from 'shared/@types';
import { BaseModalRef } from 'shared/components/base-modal';

export type ExpandableBaseRef = {
  open: () => void;
  close: () => void;
};

export const ExpandableBase = forwardRef<
  BaseModalRef,
  Props<{
    title: string;
    currentLabel: string;
    testID?: string;
  }>
>(({ children, title, currentLabel, testID }, ref) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => setIsExpanded(true),
    close: () => setIsExpanded(false),
  }));

  return (
    <View className={'border-brand-brown-dark/10 border-b'}>
      <TouchableOpacity
        className={'flex-row items-center px-3 py-2 hover:opacity-75'}
        testID={testID}
        onPress={() => setIsExpanded(!isExpanded)}
      >
        <Text className={'text-brand-brown-dark flex-1 font-semibold'}>{title}</Text>

        <Text className={'text-brand-brown-dark px-1.5'}>{currentLabel}</Text>

        <Icon icon={falAngleDown} className={'text-brand-brown-dark size-4'} />
      </TouchableOpacity>

      {Platform.OS === 'web' ? (
        <View className={isExpanded ? '' : 'hidden'}>{children}</View>
      ) : isExpanded ? (
        <View>{children}</View>
      ) : null}
    </View>
  );
});

ExpandableBase.displayName = 'ExpandableBase';
